import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class CalculosImportacionService extends ApiService {
  entityType = EntityType.CALCULO_IMPORTACION;
  url = 'api/calculo-importacion/';
}
